/*global qq */
qq.version = "5.11.4";
